import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { loaderStateTrue, loaderStateFalse } from '../../../../Actions/AllAction';
import { setUserCredentials } from '../../../../GlobalModules/Login/Actions/LoginAction';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { folioHistoryList, folioDetailsApi } from '../Controller/BookingController';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
import CommonDateTimePicker from '../../../../Utility/Components/CommonDateTimePicker'
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary'
import ModalGlobal from '../../../../Utility/Components/ModalGlobal'
import FolioDetails from './FolioDetails'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import PaymentViewModalContent from '../../Home/Components/PaymentViewModalContent';
import Utility from '../../../../Utility/Utility'

function FolioHistory(props) {
    const [folioDataStatus, setFolioDataStatus] = useState(false);
    const [scrollEnabled, setScrollEnabled] = useState(true);
    const [folioOffset, setFolioOffset] = useState(0);
    const [folioLimit, setFolioLimit] = useState(3);
    const [hasMoreFolioList, setHasMoreFolioList] = useState(true)
    const [hotelFolioHistoryData, setHotelFolioHistoryData] = useState([])
    const [searchFolioHistoryData, setSearchFolioHistoryData] = useState("");
    const [serachFlag, setSerachFlag] = useState(false);
    const folioContentRef = useRef(true);
    const [folioStartDate, setFolioStartDate] = useState(null);
    const [folioEndDate, setFolioEndDate] = useState(null);
    const [dateRangeFilterFlag, setDateRangeFilterFlag] = useState(false);
    const [viewFolioId, setViewFolioId] = useState("");
    const [viewFolioDetailsModalFlag, setViewFolioDetailsModalFlag] = useState(false);
    const [viewDetailsData, setViewDetailsData] = useState({});
    const [paymentDetailsModalFlag, setPaymentDetailsModalFlag] = useState(false);
    const [bookingStatus, setBookingStatus] = useState('');
    const [paymentHistoryShowFlag, setPaymentHistoryShowFlag] = useState(false);
    const [selectedFolioObj, setSelectedFolioObj] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [userDetailsData, setUserDetailsData] = useState({})
useEffect(() => {
    // console.log("props.isLoggedIn",props.isLoggedIn)
    if (!props.isLoggedIn) {
      props.history.push(`/${localStorage.getItem('i18nextLng')}/login`);
    } 
  }, [props.isLoggedIn]);
    useEffect(() => {
        if (folioContentRef.current) {
            folioContentRef.current = false;
            folioHistoryListFn();
        }
    }, []);

    const folioHistoryListFn = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let promise = new Promise((resolve, reject) => {
            setFolioDataStatus(false)
            loaderStateTrue();
            setScrollEnabled(false)
            let filters = {};
            let filter_op = {};
            let globalQueryParamshash = {};
            // globalQueryParamshash["limit"] = folioLimit.toString();
            // globalQueryParamshash["offset"] = folioOffset.toString();
            globalQueryParamshash["folio_type"] = "master";

            // let startDate = moment(folioStartDate).format('YYYY-MM-DD')
            // let endDate = moment(folioEndDate).format('YYYY-MM-DD')

            // if (folioStartDate && folioStartDate != "" && folioEndDate && folioEndDate != "") {
            //     globalQueryParamshash['book_from'] = startDate + " " + "00:00:00"
            //     globalQueryParamshash['book_to'] = endDate + " " + "23:59:59";
            // }

            // if (searchBookingData !== "") {
            //     globalQueryParamshash['search_attr'] = searchBookingData;
            //     filter_op = Object.assign(filter_op, { "search_attr": "substring" });
            // }

            // if (selectedStatus != "") {
            //     globalQueryParamshash['book_status'] = selectedStatus.value;
            // }

            // if (Object.keys(filter_op).length > 0) {
            //     filters["filter_op"] = JSON.stringify(filter_op);
            // }
            if (Object.keys(globalQueryParamshash).length > 0) {
                filters['filters'] = JSON.stringify(globalQueryParamshash);
            }
            folioHistoryList(filters).then((response) => {
                // console.log("response----",response)
                if (response.success) {
                    setScrollEnabled(true)
                    resolve(response)
                } else {
                    setFolioDataStatus(true)
                }
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {

                }
                loaderStateFalse();
                setFolioDataStatus(true)
                if (error.message == "Network Error") {
                }
            });

        })
        promise.then((res) => {
            res.total == 3
            if (res.total > 0 || res.data.length > 0) {
                setHasMoreFolioList(true)
                if (folioOffset <= res.total) {
                    let tempOffset = folioOffset + folioLimit
                    setFolioOffset(tempOffset)
                    let tempAllBookingRoomData = hotelFolioHistoryData.slice()
                    let finalBookingRoomData = tempAllBookingRoomData.concat(res.data);
                    setTimeout(() => {
                        setHotelFolioHistoryData(finalBookingRoomData)
                        setFolioDataStatus(true)
                        setScrollEnabled(true)
                    }, 500)
                } else {
                    setHasMoreFolioList(false)
                    setScrollEnabled(true)
                    setTimeout(() => {
                        setFolioDataStatus(true)
                    }, 500)

                }
                if (res.data.length == 0) {
                    setHasMoreFolioList(false)
                    setScrollEnabled(true)
                    setTimeout(() => {
                        setFolioDataStatus(true)
                    }, 500)
                }
            } else {
                setHasMoreFolioList(false)
                setScrollEnabled(true)
                setTimeout(() => {
                    setFolioDataStatus(true)
                }, 500)
            }


        })
    }


    //when scroll , list api call and fetch more data
    const getNextData = () => {
        folioHistoryListFn()
    }

    //booking date range filter onchange event
    const onChangeDateRange = (dates) => {
        const [start, end] = dates;
        setFolioStartDate(start);
        setFolioEndDate(end);
        setHotelFolioHistoryData([])
        setfolioOffset(0)
        setFolioLimit(3)
        //
        setDateRangeFilterFlag(true)
    }

    useEffect(() => {
        if (folioOffset == 0 && hotelFolioHistoryData.length == 0) {
            setHotelFolioHistoryData([])
        }
    }, [folioOffset])


    useEffect(() => {
        if (folioStartDate && folioStartDate != "" && folioEndDate && folioEndDate != "" && dateRangeFilterFlag) {
            folioHistoryListFn();
        }
        else if (folioStartDate == null && folioEndDate == null && dateRangeFilterFlag) {
            folioHistoryListFn();
        }
    }, [folioEndDate, dateRangeFilterFlag])

    //booking id search filter handler
    const handleSearchValue = (e) => {
        if (e.target.value != "") {
            setSearchFolioHistoryData(e.target.value)
            setfolioOffset(0)
            setHotelFolioHistoryData([])
            setFolioLimit(3)

        } else {
            setSearchFolioHistoryData("")
            setfolioOffset(0)
            setFolioLimit(3)
        }
        setSerachFlag(true)
    }

    // clear booking id search fn
    const clearSearchValue = () => {
        setSearchFolioHistoryData("")
        setSerachFlag(true)
        setHotelFolioHistoryData([])
        setfolioOffset(0)
        setFolioLimit(3)
    }

    // search booking id change list api hit
    /*useEffect(() => {
        if (searchBookingData != "") {
            setfolioOffset(0)
            setFolioLimit(3)
        }
        if (searchBookingData.length == 0) {
            setfolioOffset(0)
            setFolioLimit(3)
        }


    }, [searchBookingData])

    useEffect(() => {
    }, [searchBookingData, folioStartDate, folioEndDate])*/


    useEffect(() => {
    }, [hasMoreFolioList])

    useEffect(() => {
        // console.log("hotelFolioHistoryData=========", hotelFolioHistoryData)
    }, [hotelFolioHistoryData])


    //booking list dynamic ui
    /*const hotelFolioDataUi = () => {
        let labelArray = []
        if (hotelFolioHistoryData.length > 0) {
            hotelFolioHistoryData.map((folioObj, idx) => {
                console.log("folioObj=========", folioObj)
                labelArray.push(<div className='booking-history-box' key={idx}>
                    <div className='booking-history-box-inner'>

                    </div >
                </div >)
            })
        } else if (hotelFolioHistoryData.length == 0) {
            labelArray = []
            if (folioDataStatus == true) {
                labelArray.push(<div className='noDataFound'>
                    {folioDataStatus &&
                        <h3 className='title'>No Data Found.</h3>
                    }
                </div>)
            }

        }

        return labelArray
    }*/
    const hotelFolioDataUi = () => {
        if (hotelFolioHistoryData.length === 0 && folioDataStatus) {
            return (
                <div className='noDataFound'>
                    <h3 className='title'>No Data Found.</h3>
                </div>
            );
        }

        return hotelFolioHistoryData.map((folioObj, idx) => {
            const {
                folio_number,
                booking_id,
                createdAt,
                FolioCreatedByUser,
                status,
                drTotal,
                crTotal,
                dueTotal
            } = folioObj;

            const customer_name = FolioCreatedByUser ? `${FolioCreatedByUser.first_name ?? ''} ${FolioCreatedByUser.last_name ?? ''}`.trim() : 'N/A';
            const customer_phone = FolioCreatedByUser?.contact_number ?? 'N/A';
            const customer_email = FolioCreatedByUser?.email ?? 'N/A';
            const company_name = FolioCreatedByUser?.company_name ?? 'N/A';
            const transfer_date = createdAt ? moment(createdAt).format("DD-MM-YYYY") : 'N/A';

            return (
                <div className='booking-history-box' key={idx} onDoubleClick={() => handleRowDoubleClick(folioObj, idx)}>
                    {/* <div className='booking-history-box-inner'>
                        <div className="folio-card">
                            <div className="folio-card-row">
                                <strong>Folio Number:</strong> {folio_number ?? 'N/A'}
                            </div>
                            <div className="folio-card-row">
                                <strong>Booking ID:</strong> {booking_id ?? 'N/A'}
                            </div>
                            <div className="folio-card-row">
                                <strong>Customer Name:</strong> {customer_name}
                            </div>
                            <div className="folio-card-row">
                                <strong>Phone:</strong> {customer_phone}
                            </div>
                            <div className="folio-card-row">
                                <strong>Email:</strong> {customer_email}
                            </div>
                            <div className="folio-card-row">
                                <strong>Company Name:</strong> {company_name}
                            </div>
                            <div className="folio-card-row">
                                <strong>Transfer Date:</strong> {transfer_date}
                            </div>
                        </div>
                    </div> */}
                    <div className='booking-history-box-inner'>
                        <div className='leftSection'>
                            <div className='hotel-room-details'>
                                <div className='booking-history-branch-details'>
                                    <div className='hotel-name'>
                                        <h2 className='bookingId'><span>Folio No:</span> {folio_number ?? 'N/A'}</h2>
                                    </div>
                                    <div className='hotelCheckinCheckoutInner'>
                                        <div className='bookinginnerBox hotelContact'>
                                            <div className="hotelContactLabel title">Organization Contact</div>
                                            <div className="hotelContactLabel">{customer_email ? <>
                                                {customer_email.length > 30 ?
                                                    <OverlayTrigger overlay={<Tooltip>{customer_email}</Tooltip>}>
                                                        <span><i className="fa fa-envelope" aria-hidden="true"></i> {(customer_email).substring(0, 27) + "..."}</span>
                                                    </OverlayTrigger>
                                                    :
                                                    <span><i className="fa fa-envelope" aria-hidden="true"></i> {customer_email}</span>}
                                            </> : ""}</div>
                                            <div className="hotelContactLabel">{<i className="fa fa-phone-square" aria-hidden="true"></i>} {customer_phone ? customer_phone.includes("+") ? customer_phone : "+" + customer_phone : ""}</div>
                                        </div>
                                    </div>
                                    <div className='bookinginnerBox amountSection'>
                                        <div className='amountLabel'>Booking Amount: <span className='amount'>{Utility.getCurrencySymbol('INR')} {parseFloat(drTotal).toFixed(2)}</span></div>

                                        <div className='amountLabel'>Billing Amount: <span className='amount'>{Utility.getCurrencySymbol('INR')} {parseFloat(drTotal).toFixed(2)}</span></div>

                                        <div className='amountLabel'>Paid Amount: <span className='amount'>{Utility.getCurrencySymbol('INR')} {crTotal != '' || crTotal != null ? parseFloat(crTotal).toFixed(2) : ""}</span></div>

                                        <div className='amountLabel'>Due Amount: <span className='amount'>{Utility.getCurrencySymbol('INR')} {dueTotal != '' || dueTotal != null ? parseFloat(dueTotal).toFixed(2) : ""}</span></div>

                                    </div>
                                </div>
                            </div>


                        </div>

                        <div className='rightSection'>
                            <div className='hotel-room-action'>
                                <div className="group_single_action">
                                    <OverlayTrigger
                                        rootClose
                                        trigger="click"
                                        placement="bottom"
                                        overlay={
                                            <Popover className="group_single_action_inner">
                                                <Popover.Body>
                                                    <div className="group_action_row">

                                                        < button className="group_action_btn_popup">
                                                            <span className='group_action_btn_popup_text' onClick={(e) => { handleRowDoubleClick(folioObj, idx) }}>Folio details</span>
                                                        </button>
                                                        {/* {status == "open" ?
                                                            <button className="group_action_btn_popup" onClick={(e) => { makePayment(folioObj, 'pay') }}>
                                                                <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Payments</span></span>
                                                            </button>
                                                            : <button className="group_action_btn_popup">
                                                                <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text' onClick={(e) => { makePayment(folioObj, 'history') }}>Payments</span></span>
                                                            </button>} */}

                                                    </div>
                                                </Popover.Body>
                                            </Popover>
                                        }
                                    >
                                        <button className='ellipsisBtn'><i className="fa fa-ellipsis-v"></i></button>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            );
        });
    };

    const handleRowDoubleClick = (data, idx) => {
        setViewFolioDetailsModalFlag(true)
        setViewFolioId(data.id)
        setSelectedFolioObj(data)
        // folioDetails(data, idx);
    }

    //view booking details close fn
    const closeViewFolioDetails = () => {
        setViewFolioDetailsModalFlag(false)
        setViewFolioId("")
        setSelectedFolioObj([])
        folioHistoryListFn()
        // setViewDetailsData({})
    }

    //make payment fn
    const makePayment = (folioObj, type) => {
        // console.log("folioobje====",folioObj)
        /*setSerachFlag(false)
        setShowPaymentModal(true);
        setUserDetailsData({
            folio_id: folioObj?.id,
            currency: folioObj?.currency,
            due_amount: folioObj?.dueTotal,
            total_amount: folioObj?.drTotal,
            booking_id: folioObj?.folio_number,
            booking_master_id: folioObj?.booking_id,
            customer_id: folioObj?.customer_id,
            BookingMasterBranchData: folioObj?.BookingMasterBranchData
        });
        setBookingStatus(folioObj?.status)
        setPaymentDetailsModalFlag(true);
        if (type == 'history')
            setPaymentHistoryShowFlag(true)*/
    }

    const closePaymentModal = () => {
        setShowPaymentModal(false);
    }

    //paymet modal close function
    const closePaymentModalFunction = () => {
        // setHotelBookingData([])
        // setSerachFlag(true)
        // setBookingRoomOffset(0)
        // setBookingRoomLimit(3)
        setPaymentDetailsModalFlag(false)
        setPaymentHistoryShowFlag(false)
    }
    //paymet modal close function
    const closePaymentModalFn = () => {
        // setSerachFlag(true)
        // setBookingRoomOffset(0)
        // setBookingRoomLimit(3)
        setPaymentDetailsModalFlag(false)
        setPaymentHistoryShowFlag(false)
    }
    const skipPaymentFn = () => { }


    return (
        <div className="booking-history-page">
            <div className='filterBoxCover'>
                <div className='container'>
                    <div className='filterBox bookingHistory filterBoxMBottom'>
                        <div className='leftSectionFilter'>
                            <h2 className='pageTitle'>Folio History</h2>
                        </div>
                        <div className='rightSectionFilter'>
                            {/* <div className='search-range'>
                                <ErrorBoundary title="CommonDateTimePicker Error">
                                    <img className="ico ico-date" src={require('../../../../Utility/Public/images/calendar-outline1.png')} />
                                    <CommonDateTimePicker
                                        selected={folioStartDate}
                                        onChange={(e) => onChangeDateRange(e)}
                                        showTimeSelect={false}
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="Select Date Range"
                                        startDate={folioStartDate}
                                        endDate={folioEndDate}
                                        minDate=""
                                        dateRange={true}
                                        selectsRange={true}
                                        isClearable={true}
                                    />
                                </ErrorBoundary>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="bookingHistoryContainer folio-history-container"
            >
                <div className='container'>
                    <div id="scrollableDiv" className='bookingHistoryContainerInner' >
                        <InfiniteScroll
                            dataLength={hotelFolioHistoryData.length}
                            next={getNextData}
                            hasMore={hasMoreFolioList}
                            scrollableTarget="scrollableDiv"
                        >
                            <div className='booking-history-boxes'>
                                {hotelFolioDataUi()}

                            </div>
                        </InfiniteScroll>
                    </div>
                </div>
            </div>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={viewFolioDetailsModalFlag}
                    onHide={closeViewFolioDetails}
                    title={<div>Folio Details</div>}
                    className="modalcustomize mondimension viewBookingDetailsModal viewBookingDetailsModalDialog"
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn"
                    cancelShow={true}
                    body={
                        <>
                            <ErrorBoundary title="FolioDetails Error">
                                <FolioDetails
                                    folioId={viewFolioId}
                                // template_type={selectedGridObj?.template_type || ""}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            {/* {paymentDetailsModalFlag && <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={paymentDetailsModalFlag}
                    onHide={paymentHistoryShowFlag ? closePaymentModalFunction : closePaymentModalFn}
                    title={bookingStatus == "Yet to confirm" ? <div>Payment <span className='yet_to_confirm'>(Yet to confirm)</span></div> : <div>Payment</div>}
                    className="modalcustomize mondimension paymentModalBX"
                    footer={false}
                    closeButton={true}
                    cancelButtonLabel={"Cancel"}
                    cancelButtonClassName="modbtn cancelbtn"
                    footerClassName="text-center topspace"
                    body={
                        <>
                            <ErrorBoundary title="BranchAddEditModalContent Error">
                                <PaymentViewModalContent
                                    bookingId={userDetailsData.booking_id}
                                    bookingMasterId={userDetailsData.booking_master_id}
                                    customerId={userDetailsData.customer_id}
                                    closePaymentModalFn={paymentHistoryShowFlag ? closePaymentModalFunction : closePaymentModalFn}
                                    skipPaymentFn={skipPaymentFn}
                                    bookingStatus={bookingStatus == "open" ? true : false}
                                    paymentHistoryShowFlag={paymentHistoryShowFlag ? true : false}
                                    OriginalbookingStatus={bookingStatus}
                                    paymentModalCallFrom="folioHistory"
                                    callFrom="folioHistory"
                                    bankInfoForPayments={userDetailsData}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>} */}

        </div>
    )
}



const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials
    };
}


export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials })(withNamespaces()(FolioHistory));

